<template>
    <div
            id="e3"
            style="margin: auto;"
            class="grey lighten-3"
    >
        <v-flex xs12>
            <v-card color="secondary" dark>
                <v-card-title primary-title>
                    <div>
                        <div class="headline">Reporte excel</div>
                        <v-spacer></v-spacer>
                    </div>
                </v-card-title>
            </v-card>
        </v-flex>
        <v-card>
            <v-card-title>
                <v-btn @click="loadData" large color="primary">Actualizar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="exportProcesses"
                    :search="search"
            >
                <template v-slot:items="props">
                    <td class="text-xs-right">{{ getFormattedDate(props.item.fechaCreacion) }}</td>
                    <td class="text-xs-right">{{ props.item.idCliente.name }}</td>
                    <td class="text-xs-right">{{ props.item.idTipoExamen }}</td>
                    <td class="text-xs-right">{{ props.item.fechaInicio }}</td>
                    <td class="text-xs-right">{{ props.item.fechaFin }}</td>
                    <td class="text-xs-right">{{ props.item.idAgencia==null?"TODOS":props.item.idAgencia.name }}</td>
                    <td class="text-xs-right">{{
                        props.item.idPuestoTrabajo==null?"TODOS":props.item.idPuestoTrabajo.name }}
                    </td>
                    <td class="text-xs-right">{{ props.item.estado }}</td>
                    <td class="text-xs-right">{{ props.item.usuarioCreacion }}</td>
                    <td>
                        <v-flex xs12 sm3>
                            <a v-if="props.item.estado=='FINALIZADO'" :href="props.item.reportUrl">Descargar</a>
                        </v-flex>
                    </td>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                headers: [
                    {
                        text: 'Fecha proceso',
                        align: 'left',
                        value: 'fechaCreacion'
                    },
                    {text: 'Empresa', value: 'idCliente.name'},
                    {text: 'Tipo', value: 'idTipoExamen'},
                    {text: 'Desde', value: 'fechaInicio'},
                    {text: 'Hasta', value: 'fechaFin'},
                    {text: 'Planta', value: 'idAgencia.name'},
                    {text: 'Puesto', value: 'idPuestoTrabajo.name'},
                    {text: 'Estado', value: 'estado'},
                    {text: 'Usuario', value: 'usuarioCreacion'},
                    {text: 'Descargar'}
                ],
                exportProcesses: [],
                camposSeleccionados: []
            }
        },
        computed: {
            todosLosCampos() {
                return this.camposSeleccionados.length === this.campos.length
            },
            noTodosLosCampos() {
                return this.camposSeleccionados.length > 0 && !this.todosLosCampos
            },
            icon() {
                if (this.todosLosCampos) return 'mdi-close-box'
                if (this.noTodosLosCampos) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
        methods: {
            toggle() {
                this.$nextTick(() => {
                    if (this.todosLosCampos) {
                        this.camposSeleccionados = []
                    } else {
                        this.camposSeleccionados = this.campos.slice()
                    }
                })
            },
            loadData() {
                this.exportProcesses = []
                this.$store.dispatch('getAllExportProcesses').then(response => {
                    for (var i = 0; i < response.data.length; i++) {
                        this.exportProcesses.push(response.data[i]);
                    }
                    this.$store.state.progress = false;
                }, error => {
                    this.$store.state.dialogError = true
                });
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                }  else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
        },
        created() {
            this.loadData()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/exportProcess/ExportProcessList.vue